import {
    BANNER_TYPE_INVALID_FINANCE_TYPE_CHANGED,
    BANNER_TYPE_NO_BANNER,
    BANNER_TYPE_BALANCE_ISSUE,
    BANNER_TYPE_PRICE_DECREASE,
    BANNER_TYPE_PRICE_INCREASE,
    BANNER_TYPE_VIN_CHANGED,
    PRICE_COMPARISON_CHANGES_ENBALED
} from 'constants/pdsConstant'
import { useEffect } from 'react'
import { pdsAnalytics } from 'analytics/pdsAnalytics'

export const useBannerTypeCheck = (orderType, response, priceComparisonResponse = {}) => {
    let getBannerType = (priceComparisonResponse) => {
        if (priceComparisonResponse?.vinNumberChanged) {
            return BANNER_TYPE_VIN_CHANGED
        }
        if (priceComparisonResponse?.invalidFinanceTypeConversion) {
            return BANNER_TYPE_INVALID_FINANCE_TYPE_CHANGED
        }
        if (priceComparisonResponse?.other != 0) {
            return BANNER_TYPE_BALANCE_ISSUE
        }
        if (!priceComparisonResponse?.increaseTotal && !priceComparisonResponse?.decreaseTotal) {
            return BANNER_TYPE_NO_BANNER
        }
        if (priceComparisonResponse?.total < 0) {
            return BANNER_TYPE_PRICE_DECREASE
        }
        if (priceComparisonResponse?.total > 0) {
            return BANNER_TYPE_PRICE_INCREASE
        }
        return null
    }

    let getRadUIVersion = () => {
        let x = window.innerWidth
        let y

        if (x < 768) {
            y = 'mobile'
        } else if (x < 992) {
            y = 'tablet'
        } else {
            y = 'pc'
        }

        return 'ui:rad:' + y
    }

    useEffect(() => {
        let bannerType = null

        if (PRICE_COMPARISON_CHANGES_ENBALED && response?.data && Object.keys(priceComparisonResponse).length) {
            bannerType = getBannerType(priceComparisonResponse)
        }

        const eventValues = {
            bannerType: bannerType,
            orderType: orderType.toLowerCase() || '',
            orderId: response?.data?.orderId || '',
            rad: getRadUIVersion(),
            paCode: response?.data?.paCode || '',
            brand: response?.data?.vehicle?.make || '',
            modelName: response?.data?.vehicle?.model || '',
            modelYear: response?.data?.vehicle?.year || '',
            trimStyleDescription: response?.data?.vehicle?.style || '',
            paymentMethod: response?.data?.financeType || '',
            vehicleCategory: response?.data?.vehicleCategory || 'Electric',
            sateliteTrackId: 'dynamicManageDeliverySummary'
        }
        if (response?.data) {
            pdsAnalytics.onLoad('BannerTypeOnload', eventValues)
        }
    }, [priceComparisonResponse])
}
